import { useEffect, useState } from 'react'
import { Card, CardBody } from 'reactstrap'
import AxiosInstance from 'utils/AxiosInstance'
import CreateJobInput from '../CreateJob/CreateJobInput'

function CreateInterviewCard({ application, data, onChange }) {
  const [admins, setAdmins] = useState([])

  useEffect(() => {
    AxiosInstance.get(`/users/admins`).then((data) => {
      setAdmins(
        data?.map((el) => ({
          name: `${el.first_name} ${el.last_name}`,
          id: el.id,
        }))
      )
    })
  }, [])

  return (
    <Card className='mt-5'>
      <CardBody>
        <div className='d-flex flex-wrap w-100 ' style={{ gap: '0rem 1rem' }}>
          <CreateJobInput
            id='jobApplication'
            label='Job Application'
            placeholder='Select Application'
            required
            fullSize
            select
            selectedOptions={[{ name: application.name }]}
          />
          <CreateJobInput
            id='joiningDate'
            label='Assign Employee'
            placeholder='Select Employee'
            required
            fullSize={false}
            select
            options={admins}
            selectedOptions={data.selectedAdmins || []}
            onChange={(val) => onChange('selectedAdmins', val)}
          />
          <CreateJobInput
            id='interviewDate'
            label='Interview Date'
            required
            fullSize={false}
            type='date'
            defaultValue={data.interviewDate}
            onChange={(val) => onChange('interviewDate', val)}
          />
          <CreateJobInput
            id='interviewTime'
            label='Start Time'
            type='time'
            required
            fullSize={false}
            defaultValue={data.interviewTime}
            onChange={(val) => onChange('interviewTime', val)}
          />
          <CreateJobInput
            id='endInterviewTime'
            label='End Time'
            type='time'
            required
            fullSize={false}
            defaultValue={data.endInterviewTime}
            onChange={(val) => onChange('endInterviewTime', val)}
          />
          <CreateJobInput
            id='meetingInfo'
            placeholder='Enter meeting info (e.g: link)'
            label='Meeting Info'
            fullSize
            type='textarea'
            defaultValue={data.meetingInfo}
            onChange={(val) => onChange('meetingInfo', val)}
          />
          <CreateJobInput
            id='comment'
            placeholder='Enter Comment'
            label='Comment'
            fullSize
            type='textarea'
            defaultValue={data.comment}
            onChange={(val) => onChange('comment', val)}
          />
        </div>
      </CardBody>
    </Card>
  )
}

export default CreateInterviewCard
